<template>
    <div class="lookup-container">
        <div class="lookup-filter">
            <select v-model="eventSearchTerm" style="float: left" class="m-r-sm" @change="onSearchTermChange($event)">
                <option v-show="!isPriceCheck" value="test-event" placeholder="Click SEARCH to load the test event">Test Event</option>
                <option value="external-id" placeholder="Find event by ext. id (within last 30 days)">External ID
                </option>
                <option value="lead-id" placeholder="Find event by lead id (within last 30 days)">Lead ID</option>
            </select>
            <input
                v-model="eventSearchQuery"
                :placeholder="placeholderText"
                class="text-input m-r-sm"
                style="float: left; flex-grow: 1; height: 40px"
            />
            <button
                class="btn v2_btn v2_btn-primary v2_btn-transparent"
                v-on:click="retrieveRawRequestEvent"
                :disabled="loading"
                style="float: left; padding: 9px 25px"
            >
                Search
            </button>
        </div>
    </div>
</template>


<script>
export default {
    name: 'EventLookup',
    props: {
        event: {
            type: String,
            default: '',
            require: true,
        },
        isPriceCheck: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            placeholderText: 'Click SEARCH to load the test event',
            loading: false,
            eventSearchTerm: this.isPriceCheck ? 'external-id' : 'test-event',
            eventSearchQuery: null,
        }
    },
    methods: {
        onSearchTermChange: async function (event) {
            this.placeholderText = event.target.options[event.target.options.selectedIndex].getAttribute('placeholder')
        },
        retrieveRawRequestEvent: async function () {
            this.loading = true

            try {
                let requestUrl = `/api/tools/charge-service/search-raw-request?term=${this.eventSearchTerm}&q=${this.eventSearchQuery}`
                if (this.$store.state.formulaEntity) {
                    requestUrl += `&pc=${this.$store.state.formulaEntity.product_category_id}`
                }
                const response = await axios.get(requestUrl)

                if (response.data.error) {
                    this.errors.push({
                        field: 'xhr',
                        message: 'Formula failed to execute for specified event.',
                    })
                }

                if (response.data.success) {
                    if (response.data.event_payload) {

                        if (response.data.event_payload.description) {
                            this.placeholderText = response.data.event_payload.description
                        }

                        const fetchedEvent = JSON.stringify(response.data.event_payload.event ?? response.data.event_payload,
                            null, 4)
                        this.$emit('update:event', fetchedEvent)
                    } else {
                        alert('Event not found for the search criteria')
                    }
                }
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped>
.lookup-container {
    margin-bottom: 10px;
    white-space: nowrap;
}

.lookup-filter {
    display: flex;
}

.v2_btn-primary {
    border: solid #4e63ff 1px;
}

.v2_btn-transparent {
    background: transparent;
}

.v2_btn {
    cursor: pointer;
}

.v2_btn:hover {
    transform: scale(1.015);
    animation: 500ms ease-in-out forwards;
}
</style>
